type ScoreVariant = "initial" | "penalized" | "credit-applied";

export function getScoreColor(
  variant: ScoreVariant,
  theme: {
    palette: {
      text: { primary: string };
      error: { main: string };
      intent?: { error: { text: string } };
    };
  }
): string {
  if (variant === "penalized") {
    return theme.palette.intent?.error.text ?? theme.palette.error.main;
  }

  // "initial" and "credit-applied" both use primary
  return theme.palette.text.primary;
}
